
import { MODULE } from "@/config/modules";
import { Sale } from "@/models/base";
import { ModuleElectronischeFacturatie } from "@/models/dossier/module-electronische-facturatie";
import {AuthService, DossierConfigService} from "@/services";
import Vue from "vue";
import AppSendViaPeppolModalBillit from "./SendViaPeppolModalBillit.vue";
import AppSendViaPeppolModalWf from "./SendViaPeppolModalWf.vue";
import AppPeppolCompleteSettings from "./PeppolCompleteSettings.vue";
import {IPeppolRegistration, PeppolService} from "@/services/peppol-service";
import AppPeppolRegistrationModal from "@/components/inbox/PeppolRegistrationModal.vue";


export default Vue.extend({
	data() {
		return {
			settings: DossierConfigService.getPluginConfig(),
			registrations: [] as IPeppolRegistration[],
			showRegistration: false
		};
	},
	props: {
		sale: {
			type: Object as() => Sale,
			required: true
		}
	},
	computed: {
		arePeppolSettingsComplete():boolean{
			if(!AuthService.wfDossier.isFilledIn()){
				return false;
			}
			if(!this.settings.UBL.isPeppolConfigured()){
				return false;
			}
			return true;
		},
		useWfPeppol():boolean {
			let mod = AuthService.wfCompany.Modules.find(m=>m.ID == MODULE.ELECTRONISCHE_FACTURATIE) as ModuleElectronischeFacturatie;
			if (!mod) return false;
			return mod.getUseWinfaktPeppol();
		}
	},
	methods: {
		async finish(){
			await AuthService.getUserInfo();
			this.settings = DossierConfigService.getPluginConfig();
		},
		close() {
			this.$emit("close", false);
		},
	},
	async mounted() {
		this.registrations = await PeppolService.getRegistrationData();
		if(this.registrations.length == 0){
			this.showRegistration = true;
		}
	},
	components: {
		AppSendViaPeppolModalBillit,
		AppSendViaPeppolModalWf,
		AppPeppolCompleteSettings,
		AppPeppolRegistrationModal
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
